import { useAppDispatch } from "app/hooks";
import Root from "./Root";
import LayoutProvider from "./layouts";
import RoutesProvider from "router";
import { IdleTimerProvider } from "context/IdleTimerContext";
import { logout } from "features/users";

type Props = {};




function App(props: Props) {
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logout());

  };
  return (
    <Root>
      <IdleTimerProvider onLogout={handleLogout}>
        <RoutesProvider>
          <LayoutProvider />
        </RoutesProvider>
      </IdleTimerProvider>
    </Root>
  );
}

export default App;
